import { Component, OnInit, ElementRef, HostBinding } from '@angular/core';
import { WolfieContextMenuComponent } from '../wolfie-context-menu/wolfie-context-menu.component';
import { WorkspaceServiceService } from '../../services/workspace-service.service';
import { WolfieContextMenuService } from '../../services/wolfie-context-menu/wolfie-context-menu.service';
import { MenuItem } from '../wolfie-context-menu/menu-item';

@Component({
  selector: 'mobile-wolfie-context-menu',
  template: require('./mobile-wolfie-context-menu.component.html'),
  styles: [require('./mobile-wolfie-context-menu.component.css')]
})
export class MobileWolfieContextMenuComponent extends WolfieContextMenuComponent {

  @HostBinding('style.left')
  get left(): string | undefined  
  {
    return '0';
  }

  @HostBinding('style.top')
  get top()
  {
    return '0';
  }

  @HostBinding('style.right')
  get right() 
  {
    return '0';
  }

  @HostBinding('style.transform')
  get transform()
  {
    return undefined;
  }

  @HostBinding('style.height.px')
  get height()
  {
    return window.screen.availHeight;
  }

  @HostBinding('style.width.px')
  get width()
  {
    return window.screen.availWidth;
  }

  @HostBinding('style.overflow-y')
  get overflow()
  {
    return this.hasOpenSubmenu? 'hidden': 'scroll';
  }
  
  get allItems()
  {
    if(this.parentItem == null || this.parentItem.mobileCallbackMenuItem == null)
      return this.items;

    return [this.parentItem.mobileCallbackMenuItem, ...this.items];
  }

  get hasOpenSubmenu()
  {
    return this.elementRef.nativeElement.querySelector('.menu-item.open') != null;
  }

  get title()
  {
    return this.contextMenuService.title;
  }

  constructor(protected elementRef: ElementRef, protected contextMenuService: WolfieContextMenuService, protected workspaceService: WorkspaceServiceService)  
  { 
    super(elementRef, contextMenuService, workspaceService);
  }

  itemAction(item: MenuItem, event: MouseEvent)
  {
    if(item.clickChangeIcon)
    {
      if(item.iconClass == item.enabledIcon)
      {
        item.iconClass = item.disabledIcon
      }
      else
      {
        item.iconClass = item.enabledIcon;
      }
    }


    event.stopPropagation();
    if(item.submenu != null && item.submenu.length > 0)
    {
      (event.currentTarget as any).classList.add('open');
      return;
    }
    if(this.parentItem != null && this.parentItem.callback != null && item == this.parentItem.mobileCallbackMenuItem)
    {
      this.parentItem.callback();
      this.contextMenuService.hide();
      return;
    }
      
    if(item.callback != undefined) 
    {
      item.callback();
    }
  }

  back(event: MouseEvent)
  {
    event.stopPropagation();
    if(this.parentItem == null)
    {
      this.contextMenuService.hide();
      return;
    }

    this.elementRef.nativeElement.parentElement.classList.remove('open');
  }

  done(event: MouseEvent)
  {
    event.stopPropagation();
    this.contextMenuService.hide();
  }
}
